module.exports = __webpack_public_path__ + "static/img/talent-fitness.68eb512.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/genestesting/talent-fitness.png
// module id = XxiI
// module chunks = 0